import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmailIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 32,
	viewBox: "0 0 40 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 32,
			rx: 4,
			fill: "#76ec71"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_612_9131)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M29 8.5H11C10.8011 8.5 10.6103 8.57902 10.4697 8.71967C10.329 8.86032 10.25 9.05109 10.25 9.25V22C10.25 22.3978 10.408 22.7794 10.6893 23.0607C10.9706 23.342 11.3522 23.5 11.75 23.5H28.25C28.6478 23.5 29.0294 23.342 29.3107 23.0607C29.592 22.7794 29.75 22.3978 29.75 22V9.25C29.75 9.05109 29.671 8.86032 29.5303 8.71967C29.3897 8.57902 29.1989 8.5 29 8.5ZM28.25 22H11.75V10.9562L19.4937 18.0531C19.632 18.1796 19.8126 18.2498 20 18.2498C20.1874 18.2498 20.368 18.1796 20.5062 18.0531L28.25 10.9562V22Z",
				fill: "#0f172b"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_612_9131",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(8 4)"
			})
		}) })
	]
});
export default SvgEmailIcon;
